import Auth0Lock from 'auth0-lock';
import config from 'config';

/*
Gist: following Auth0 Example
https://codesandbox.io/s/vvn9229vx7
*/

export function initLock(customOptions){
  const logoUrl =
    'https://res.cloudinary.com/dljcvcx8l/image/' +
    'upload/v1499458968/App_Icon_150x150_cophtz.png';

  const defaultOptions = {
    configurationBaseUrl: 'https://cdn.auth0.com',
    allowSignUp: true,
    allowLogin: true,
    allowForgotPassword: true,
    initialScreen: 'signUp',
    rememberLastLogin: false,
    closable: true,
    autoclose: true,
    avatar: null,
    theme: {
      primaryColor: '#4dba97',
      logo: logoUrl
    },
    auth: {
      //redirect mode maximizes browser compatibility
      redirect: true,
      redirectUrl: window.location.href,
      //id_token is required to get idToken from response
      responseType: 'id_token token',
      params: {
        //scope determines data sent back from lock.getUserInfo
        //https://openid.net/specs/openid-connect-core-1_0.html#StandardClaims
        scope: 'openid email profile app_metadata'
      }
    },
    // mustAcceptTerms: false,
    // languageDictionary: {
    //   signUpTerms: 'Trybe will use the information here to provide updates and marketing.\nYou can change your mind at any time by clicking the unsubscribe link in the footer of any email we send. We\'ll treat your information with respect. By clicking the checkbox, you agree that we may use the information in accordance with these terms.'
    // }
  };

  const options = Object.assign({}, defaultOptions, customOptions);

  return new Auth0Lock(
    config.authClientID,
    config.authDomain,
    options
  );
}

export function showLock(lock){
  lock.show({
    auth: {
      params: {
        //works without state, but following example
        state: window.location.pathname + window.location.search
      }
    }
  });
}

export function resumeAuth(lock, urlSource, onResumeCb){
  lock.resumeAuth(urlSource, (err, auth) => {
    onResumeCb(err, auth);
  });
}

export function getUserInfo(lock, accessToken, onGetUserInfo){
  lock.getUserInfo(accessToken, (err, profile) => {
    onGetUserInfo(err, profile);
  })
}


// WEBPACK FOOTER //
// ./src/common/auth0LockHelpers.js